import React, {PropsWithChildren} from "react";
import {observer} from "mobx-react";
import {IDialogConfirmationHandler} from "../../../services/dialog/dialog.service.interface";
import styled, {css} from "styled-components";
import {AirlineTheme} from "../../../services/theme/interfaces/airline.theme";

function computePaddings(theme: AirlineTheme, shouldPreserveBottomSafeArea: boolean, hasChildren: boolean) {
    if(shouldPreserveBottomSafeArea) {
        if(hasChildren) {
            return css`
              padding: ${theme.spacing.dialogVerticalPadding} ${theme.spacing.dialogHorizontalPadding} calc(${theme.spacing.dialogVerticalPadding} + env(safe-area-inset-bottom)) ${theme.spacing.dialogHorizontalPadding};
              border-top: 1px solid ${props => props.theme.border.mainColor};
            `
        } else {
            return css`
              padding: 0 0 env(safe-area-inset-bottom) 0;
              
            `
        }

    }

    if(hasChildren) {
        css`
              padding: ${props => props.theme.spacing.dialogVerticalPadding} ${props => props.theme.spacing.dialogHorizontalPadding};
        `
    }

    return (
        css`
            padding: 0;
        `
    )
}

const StandardFooterBox = styled.div<{shouldPreserveBottomSafeArea: boolean; horizontallyCentered?: boolean; hasChildren: boolean}>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: ${props => props.theme.spacing.flexGap16};
    width: 100%;
    ${props => computePaddings(props.theme, props.shouldPreserveBottomSafeArea, props.hasChildren)}

    ${
            props => props.horizontallyCentered
                    ? css`
                  align-items: center;
                `
                    : ''
    }

    background-color: ${props => props.theme.colors.light};
    color: ${props => props.theme.colors.lightContrast};
`


interface StandardDialogFooterComponentProps extends PropsWithChildren {
    className?: string;
    dialogHandler: IDialogConfirmationHandler;
    horizontallyCentered?: boolean;
    shouldPreserveBottomSafeArea?: boolean;
}


export const StandardDialogFooterComponent: React.FC<StandardDialogFooterComponentProps> = observer((props) => {

    const hasChildren = React.Children.count(props.children) > 0;

    const shouldPreserveBottomSafeArea = props.shouldPreserveBottomSafeArea ?? true;

    return (
        <StandardFooterBox className={props.className}
                           horizontallyCentered={props.horizontallyCentered}
                           shouldPreserveBottomSafeArea={shouldPreserveBottomSafeArea}
                           hasChildren={hasChildren}
        >
            {props.children}
        </StandardFooterBox>
    );


});
